export default {
    titulo: "Sucursales",
    nueva: "Nueva sucursal",
    eliminar: "Eliminar sucursal",
    pregEliminar: "¿Confirmas que deseas eliminar la sucursal?",
    editar: "Editar sucursal",
    tituloPadrones: "Padrones (nomenclatura o registro catastral)",
    nuevoPadron: "Nuevo padrón",
    editarPadron: "Editar padrón",
    eliminarPadron: "Eliminar padrón",
    pregEliminarPadron: "¿Confirmas que deseas eliminar el padrón?",
    nroPadron: "Nro. de padrón",
    propietario: "Propietario",
    nroServicioLuz: "Nro. servicio de luz",
    kwContratados: "KW Contratados",
    nroServicioAgua: "Nro. servicio de agua",
    diametroConexion: "Diámetro de conexión"
}